module.exports = __webpack_public_path__ + "img/55b6e42192f57eb7f86ef5104298e8d3.png";